import { Observable } from 'rxjs';
import { combineEpics } from 'redux-observable';
import { LOADING, SUCCESS, ERROR, INIT } from '../../utils/constants';
import { resetPasswordAPI, checkTokenAPI } from './api';


export const RESET_PASSWORD = 'advaice/reset-password/RESET_PASSWORD';
export const RESET_PASSWORD_SUCCESS = 'advaice/reset-password/RESET_PASSWORD_SUCCESS';
export const RESET_PASSWORD_ERROR = 'advaice/reset-password/RESET_PASSWORD_ERROR';

export const CHECK_TOKEN = 'advaice/reset-password/CHECK_TOKEN';
export const CHECK_TOKEN_SUCCESS = 'advaice/reset-password/CHECK_TOKEN_SUCCESS';
export const CHECK_TOKEN_ERROR = 'advaice/reset-password/CHECK_TOKEN_ERROR';


export const ANNUL_ERROR = 'advaice/reset-password/ANNUL_ERROR';

const initialState = {
  resetStatus: INIT,
  resetError: '',
  checkStatus: INIT,
  checkError: '',
};
export const resetPasswordStore = (state = initialState, action = {}) => {
  switch (action.type) {
    case RESET_PASSWORD: {
      return {
        ...state,
        resetStatus: LOADING,
      };
    }
    case RESET_PASSWORD_SUCCESS: {
      return {
        ...state,
        resetStatus: SUCCESS,
      };
    }
    case RESET_PASSWORD_ERROR: {
      return {
        ...state,
        resetStatus: ERROR,
        resetError: action.payload,
      };
    }
    case CHECK_TOKEN: {
      return {
        ...state,
        checkStatus: LOADING,
      };
    }
    case CHECK_TOKEN_SUCCESS: {
      return {
        ...state,
        checkStatus: SUCCESS,
      };
    }
    case CHECK_TOKEN_ERROR: {
      return {
        ...state,
        checkStatus: ERROR,
        checkError: action.payload,
      };
    }
    case ANNUL_ERROR: {
      return {
        ...state,
        resetStatus: INIT,
      };
    }
    default: {
      return state;
    }
  }
};

export const resetPassword = data => ({
  type: RESET_PASSWORD,
  payload: data,
});

export const checkToken = data => ({
  type: CHECK_TOKEN,
  payload: data,
});

export const annulError = () => ({
  type: ANNUL_ERROR,
});
export const resetPasswordObservable = (store, requestData) =>
  Observable.fromPromise(resetPasswordAPI(requestData))
    .map(({ data }) => ({
      type: RESET_PASSWORD_SUCCESS,
      payload: data,
    }))
    .catch(err =>
      Observable.of({
        type: RESET_PASSWORD_ERROR,
        payload: err,
      }));

export const checkTokenObservable = (store, requestData) =>
  Observable.fromPromise(checkTokenAPI(requestData))
    .map(({ data }) => ({
      type: CHECK_TOKEN_SUCCESS,
      payload: data,
    }))
    .catch(err =>
      Observable.of({
        type: CHECK_TOKEN_ERROR,
        payload: err,
      }));

export const resetPasswordEpicLocal = (action$, store) => action$
  .ofType(RESET_PASSWORD)
  .flatMap(action => resetPasswordObservable(store, action.payload));

export const checkTokenEpic = (action$, store) => action$
  .ofType(CHECK_TOKEN)
  .flatMap(action => checkTokenObservable(store, action.payload));

export const resetPasswordEpic = combineEpics(resetPasswordEpicLocal, checkTokenEpic);



// WEBPACK FOOTER //
// ./src/reducers/reset-password/duck.js